<div class="cell auto" *ngIf="parameters">
    <form #externalLoadsForm="ngForm">
        <kiwi-parameters-tab-content-header [titleLabelKey]="'parameters.external.loads.title'"
                                            [saveDisabled]="areParametersReadonly() || externalLoadsForm.invalid"
                                            (saved)="updateParameters()">
        </kiwi-parameters-tab-content-header>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <p [i18nKey]="'parameters.external.loads.description'"></p>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <table class="_tableColor">
            <thead>
            <tr class="_titlePartTable">
                <th [i18nKey]="'parameters.external.loads.expenses.type'"></th>
                <th style="text-align:center"[i18nKey]="'parameters.external.loads.fixed'"></th>
                <th style="text-align:center"[i18nKey]="'parameters.external.loads.rate'"></th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td [i18nKey]="'parameters.external.loads.travel'"></td>
                <td>
                    <kiwi-currency-input
                        [(ngModel)]="parameters.fixedTravelExpenses"
                        name="fixedTravelExpenses"
                        [disabled]="areParametersReadonly()">
                    </kiwi-currency-input>
                </td>
                <td>
                    <kiwi-percentage-input
                        [(ngModel)]="parameters.travelExpensesRate"
                        name="travelExpensesRate"
                        [disabled]="areParametersReadonly()">
                    </kiwi-percentage-input>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.external.loads.postal'"></td>
                <td>
                    <kiwi-currency-input
                        [(ngModel)]="parameters.fixedPostalCharges"
                        name="fixedPostalCharges"
                        [disabled]="areParametersReadonly()">
                    </kiwi-currency-input>
                </td>
                <td>
                    <kiwi-percentage-input
                        [(ngModel)]="parameters.postalChargesRate"
                        name="postalChargesRate"
                        [disabled]="areParametersReadonly()">
                    </kiwi-percentage-input>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.external.loads.consumables'"></td>
                <td>
                    <kiwi-currency-input
                        [(ngModel)]="parameters.fixedConsumablesCost"
                        name="fixedConsumablesCost"
                        [disabled]="areParametersReadonly()">
                    </kiwi-currency-input>
                </td>
                <td>
                    <kiwi-percentage-input [(ngModel)]="parameters.consumablesCostTurnoverRate"
                                           name="consumablesCostTurnoverRate"
                                           [disabled]="areParametersReadonly()">
                    </kiwi-percentage-input>
                </td>
            </tr>
            </tbody>
        </table>
    </form>
</div>
